import React, { useContext, useState } from "react";
import PropTypes from "prop-types";

import { ReactComponent as QuotationSvg } from "../../../assets/commission/quotation.svg";
import { ReactComponent as ReceiptSvg } from "../../../assets/commission/receipt-blue.svg";
import { ReactComponent as PencilSvg } from "../../../assets/commission/pencil-blue.svg";

import AppContext from "../../../AppContext";
import { langComponent } from "../../../constants";

const CommissionAction = ({ commission, onClick }) => {
  const { user, getLang } = useContext(AppContext);
  const Translation = getLang(langComponent.chat);
  const TranslationCommon = getLang(langComponent.common);
  const [isOwner] = useState(commission?.createdBy === user._id);

  const handleClick = () => {
    if (!commission) onClick("quotation");

    if (commission.status === 0 && isOwner) onClick("edit-quotation");

    if (commission.status === 0 && !isOwner) onClick("confirm-quotation");

    if (commission.status === 1 && !isOwner) onClick("pay");

    if (commission.status === 2 && isOwner) onClick("submit-draft");
  };

  const getRender = () => {
    // * Display create quotation button if no current commission is in progress
    if (!commission) {
      return (
        <div className="chat-commission-action-button chat-commission-action-button--create-quotation">
          <QuotationSvg />
          <span className="chat-commission-action-button__title">
            {Translation("Create commission")}
          </span>
        </div>
      );
    }

    if (commission.status === 0 && isOwner) {
      return (
        <div className="chat-commission-action-button chat-commission-action-button--edit-quotation">
          <PencilSvg />
          <span className="chat-commission-action-button__title">
            {Translation("Edit quotation")}
          </span>
        </div>
      );
    }

    if (commission.status === 0 && !isOwner) {
      return (
        <div className="chat-commission-action-button chat-commission-action-button--confirm-quotation">
          <span className="chat-commission-action-button__title">
            {Translation("Confirm quotation")}
          </span>
        </div>
      );
    }

    if (commission.status === 1 && !isOwner) {
      return (
        <div className="chat-commission-action-button chat-commission-action-button--pay">
          <ReceiptSvg />
          <span className="chat-commission-action-button__title">
            {Translation("Pay")}
          </span>
        </div>
      );
    }

    if (isOwner && commission.status === 2) {
      return (
        <div className="chat-commission-action-button chat-commission-action-button--pay">
          <ReceiptSvg />
          <span className="chat-commission-action-button__title">
            {Translation("Submit Draft")}
          </span>
        </div>
      );
    }

    return <></>;

    // // * Allow create new commission
    // return (
    //   <div className="chat-commission-action-button chat-commission-action-button--create-quotation">
    //     <QuotationSvg />
    //     <span className="chat-commission-action-button__title">
    //       Create another commission
    //     </span>
    //   </div>
    // );
  };

  return (
    <div className="chat-commission-action" onClick={handleClick}>
      {getRender()}
    </div>
  );
};

CommissionAction.propTypes = {
  onClick: PropTypes.func,
};

CommissionAction.propTypes = {
  onClick: (action) => {},
};

export default CommissionAction;
